import { Injectable } from '@angular/core';
import { merge, fromEvent, timer, Observable, Subscription, Subject } from 'rxjs';
import { AuthRedirectDebugService } from '../auth-redirect-debug.service';

@Injectable({
    providedIn: 'root',
})
export class AuthIdleService {
    private idle: Observable<Event> = new Observable();
    private timer: Subscription = new Subscription();
    private timeOutMilliSeconds = 1000;
    private idleSubscription: Subscription = new Subscription();

    readonly expired = new Subject<boolean>();

    constructor(private authRedirectDebug: AuthRedirectDebugService) {}

    startWatching(timeOutSeconds: number): Observable<boolean> {
        this.idle = merge(
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'click'),
            fromEvent(document, 'mousedown'),
            fromEvent(document, 'keypress'),
            fromEvent(document, 'DOMMouseScroll'),
            fromEvent(document, 'mousewheel'),
            fromEvent(document, 'touchmove'),
            fromEvent(document, 'MSPointerMove'),
            fromEvent(window, 'mousemove'),
            fromEvent(window, 'resize')
        );
        this.timeOutMilliSeconds = timeOutSeconds * 1000;
        this.idleSubscription = this.idle.subscribe(() => {
            this.authRedirectDebug.markUserActivity();
            this.resetTimer();
        });
        this.authRedirectDebug.markUserActivity();
        this.startTimer();
        return this.expired.asObservable();
    }

    resetTimer(): void {
        this.timer.unsubscribe();
        this.startTimer();
    }

    stopTimer(): void {
        this.timer.unsubscribe();
        this.idleSubscription.unsubscribe();
    }

    private startTimer(): void {
        this.timer = timer(this.timeOutMilliSeconds).subscribe(() => {
            this.expired.next(true);
        });
    }
}
